import React, { Component } from "react";
import { Container } from "react-bootstrap";

import Hero from "./Hero";
import Cards from "./Cards";

class HomepageContent extends Component {
  // add img props
  render() {
    return (
      <React.Fragment>
        <Hero />
        <Container>
          <h1 className="text-center">Dlaczego warto nauczyć się c++</h1>
          <Cards />
          <hr />
          <article>
            Na stronie znajdziesz przydatne inforamcje o języku programowania
            cpp
          </article>
        </Container>
      </React.Fragment>
    );
  }
}

export default HomepageContent;
